export const GENERATE_FILE_TYPES = [
  'ACT', 'CONTRACT', 'TASK'
] as const;

export const SIGNED_FILE_TYPES = [
  'SIGNED_ACT', 'SIGNED_CONTRACT', 'SIGNED_TASK', 'RECEIPT'
] as const;

export const STATISTIC_FILE_TYPES = [
  'INITIAL_VIDEO', 'FINAL_VIDEO', 'POST_STATISTICS'
] as const;

export const HYPOTHESIS_FILE_TYPES = [
  'FIRST_PHASE', 'SECOND_PHASE', 'THIRD_PHASE'
] as const;

export const NOTES_FILE_TYPES = 'NOTES_FILE';

